import { SupportedLocale } from "@/i18n";
import { computeFieldMultipleprintRelatedAuthors } from "@/lib/computeFields";
import { Multiplesample } from "@/lib/types";

export function formatMultiplesampleAuthorDisplay(
  ms: Multiplesample,
  language: SupportedLocale,
): string {
  const mp = ms.multipleprints?.[0];
  if (mp) {
    return computeFieldMultipleprintRelatedAuthors(mp, { language });
  }
  if (ms.relatedAuthor?.length) {
    return ms.relatedAuthor
      .map(
        (a) =>
          `${a.artistesAuteursDescriptionPrenom ?? ""} ${a.artistesAuteursDescriptionNom ?? ""}`.trim(),
      )
      .filter(Boolean)
      .join(", ");
  }
  return "";
}
